// extracted by mini-css-extract-plugin
module.exports = {"noResult":"noResult_noResult__3WDbb","noResultInfo":"noResult_noResultInfo__3gs1a"};